import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { KeyValuePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { TableModule } from 'primeng/table';

@Component({
  selector: 'cosmos-file-review-card',
  imports: [TranslatePipe, RouterModule, KeyValuePipe, ButtonModule, CardModule, TableModule],
  templateUrl: 'file-review-card.component.html',
  styles: `
    .children-list li { margin-left: 1rem; }
    .green  { color: var(--p-green-500); }
    .yellow { color: var(--p-amber-500); }
    .red    { color: var(--p-red-500); }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileReviewCardComponent {
  readonly file = input.required<any>();

  /**
   * Pre-computed image URL passed by the parent.
   * Built as: `${environment.API_URL}/analytics/processing-jobs/${job._id}/image`
   * Optional — if absent, the thumbnail is hidden.
   */
  readonly imageUrl = input<string | null>(null);

  getConfidenceColor(confidence: number): string {
    if (confidence > 0.95) return 'green';
    if (confidence > 0.9)  return 'yellow';
    return 'red';
  }
}
